import { toast } from '@/components/toast';
import { updateTranslationGroup } from '@/services/api';
import { logger } from '@/services/logger';
import { ITranslationGroup } from '@d-id/types';
import { useMutation, useQueryClient } from 'react-query';
import { GET_TRANSLATION_GROUPS_KEY, GET_TRANSLATIONS_KEY } from './translationLibrary';

export const useUpdateTranslationGroup = (options?: { onError?: () => void }) => {
    const queryClient = useQueryClient();
    const { onError } = options || {};

    return useMutation(
        async (payload: Pick<ITranslationGroup, 'name'> & { id: string }) => {
            const { id, ...variables } = payload;
            return updateTranslationGroup(id, variables);
        },
        {
            onError: (err: any) => {
                logger.error(`Could not update translation group`, { err });
                toast.error({ title: `Could not update video`, toastId: `library-item-update-error` });
                onError?.();
            },
            onSuccess: async ({ id }: ITranslationGroup) => {
                await queryClient.invalidateQueries(GET_TRANSLATION_GROUPS_KEY);
                await queryClient.invalidateQueries([GET_TRANSLATIONS_KEY, id]);
            },
        }
    );
};
